import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { request } from '@/api/service';
import utils from '@/utils';
export default {
  name: 'd2-message',
  data: function data() {
    return {
      select: '',
      //   total: "888",
      //   list: ["今日收益", "7天总收益", "近30天收益", "今年总收益"],
      //   active: false,
      activeName: '1',
      market_id: '',
      agent_id: '',
      start_time: '',
      days: 365,
      chartData: {
        columns: ['date', 'smscount'],
        rows: [//   { 日期: "1-1", 订单量: 8, 收益: 1213 },
          //   { 日期: "1-2", 订单量: 8, 收益: 1223 },
          //   { 日期: "1-3", 订单量: 8, 收益: 2123 },
          //   { 日期: "1-4", 订单量: 8, 收益: 4123 },
          //   { 日期: "1-5", 订单量: 8, 收益: 3123 },
          //   { 日期: "1-6", 订单量: 8, 收益: 7123 },
        ]
      },
      type: null,
      innerType: null,
      washList: []
    };
  },
  //   computed: {
  //     newList() {
  //       return this.list.map((item) => {
  //         this.$set(item, "isShow", false);
  //         return item;
  //       });
  //     },
  //   },
  //   {"market_id":1,"start_time":"2021-04-27","days":365}
  created: function created() {
    var _this = this;

    var aData = new Date();
    this.value = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
    this.start_time = this.value; // 2019-8-20

    var data = {
      // market_id: this.market_id,
      start_time: this.start_time,
      days: 7 // agent_id: this.agent_id,

    }; //   console.log("传参", data);

    request({
      method: 'post',
      url: '/api/sms-record/data',
      data: data // headers: {},

    }).then(function (res) {
      _this.chartData.rows = res.sy;
    }); //   初始化折线图
  },
  //   watch: {
  //     select: function(value) {
  //       console.log(value);
  //     },
  //   },
  methods: {
    // 切换tab栏
    handleClick: function handleClick(tab, event) {
      var _this2 = this;

      // 获取当前时间
      var aData = new Date();
      this.value = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
      this.start_time = this.value; // 2019-8-20

      var data = {
        // market_id: this.market_id,
        start_time: this.start_time,
        days: '' // agent_id: this.agent_id,

      };

      if (tab.name == '1') {
        data.days = 7;
      }

      if (tab.name == '0') {
        data.days = 7;
      }

      if (tab.name == '2') {
        data.days = 30;
      }

      if (tab.name == '3') {
        data.days = 365;
      } //   请求数据


      request({
        method: 'post',
        url: '/api/sms-record/data',
        data: data // headers: {},

      }).then(function (res) {
        _this2.chartData.rows = res.sy;
      }).catch(function (err) {
        console.log(err);
        alert('网络错误');
      });
    }
  }
};